import type {Result, UseCase} from 'framework';
import type {BodyMetricId} from '../../domain/body-metric';
import type {BodyMeasurementsError} from '../../domain/errors';
import type {MeasurementEntry} from '../../domain/measurement-entry';
import type {
  BodyMeasurementsRepository,
  MeasurementSeriesRange,
} from '../ports/body-measurements.repository';

export type GetMeasurementSeriesInput = {
  readonly metricId: BodyMetricId;
  readonly range: MeasurementSeriesRange;
};

export class GetMeasurementSeries implements UseCase<
  [GetMeasurementSeriesInput],
  readonly MeasurementEntry[]
> {
  constructor(private readonly repository: BodyMeasurementsRepository) {}

  execute(
    input: GetMeasurementSeriesInput,
  ): Promise<Result<readonly MeasurementEntry[], BodyMeasurementsError>> {
    return this.repository.getSeries(input.metricId, input.range);
  }
}
